<div class="tabs-scroll-row" [ngClass]="getThemeClass()">
  <div class="tabs-button-row">
    <button class="tab-btn" *ngFor="let tab of tabs" [class.selected]="tab.selected" (click)="onTabClick(tab)">
      <span class="material-icons tab-icon">{{ tab.icon }}</span>
      <span class="tab-label">{{ tab.label }}</span>
    </button>
  </div>
</div>
